import React from 'react'

import { string } from 'prop-types'

function BoostSales(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.201904" width="20" height="20" rx="2" fill="#4B525B" />
      <path
        d="M4.2019 15L8.53524 10.6667L11.2019 13.3334L16.2019 8.33337M16.2019 8.33337H12.8686M16.2019 8.33337V11.6667"
        stroke="white"
        strokeLinejoin="round"
      />
    </svg>
  )
}

BoostSales.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default BoostSales
